import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const RandomNumberGenerator = () => {
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isDirty, isValid },
  } = useForm({ mode: "onChange" });
  const [convertedValue, setConvertedValue] = useState(null);

  const onSubmit = (data) => {
    const minInt = parseInt(data.minValue, 10);
    const maxInt = parseInt(data.maxValue, 10);
    const random = Math.floor(Math.random() * (maxInt - minInt + 1)) + minInt;
    setConvertedValue(random);
  };

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    toast.success("Copied.");
  };

  return (
    <section className="landing-page-section bg-landing-page">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-xl-8 col-lg-8 col-md-8">
            <div className="section-title text-center title-ex1 mb-4">
              <p>
                <Link className="" to={"/utilities"}>
                  ← All Developer Utilities
                </Link>{" "}
              </p>
              <h2 className="light-purple-gradient">Random Number Generator</h2>
              <p
                className="landing-muted-text"
                style={{ fontSize: "large", fontWeight: "normal" }}
              >
                Generate a random number.
              </p>
            </div>
          </div>

          <Container>
            <Row className="dark-mode justify-content-center mb-4">
              <Col lg={12} md={8} className="">
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                  <label className="text-cool-black d-flex justify-content-center text-left">
                    Minimum Value{" "}
                  </label>
                  <div className="form-row justify-content-center">
                    <div className="form-group col-md-4">
                      <input
                        name="minValue"
                        className="form-control"
                        ref={register({ required: true, pattern: /^[0-9]+$/ })}
                        placeholder="*Enter min value"
                        defaultValue={0}
                      />
                      {errors.message && (
                        <p className="error">Value is required</p>
                      )}
                    </div>
                  </div>
                  <label className="text-cool-black d-flex justify-content-center text-center">
                    Maximum Value{" "}
                  </label>
                  <div className="form-row justify-content-center">
                    <div className="form-group col-md-4">
                      <input
                        name="maxValue"
                        className="form-control"
                        ref={register({ required: true, pattern: /^[0-9]+$/ })}
                        placeholder="*Enter max value"
                        defaultValue={10000}
                      />
                      {errors.message && (
                        <p className="error">Value is required</p>
                      )}
                    </div>
                  </div>
                  <div className="d-flex mt-1 justify-content-center">
                    <div className="form-group">
                      <button
                        className="btn btn-danger btn-block gradient-bg-accent"
                        type="submit"
                        disabled={!isDirty && !isValid}
                      >
                        {isSubmitting ? "Generating..." : "Generate"}
                      </button>
                    </div>
                  </div>
                </form>
                <div className="form pt-0">
                  <label className="text-cool-black d-flex justify-content-center text-center">
                    Generated Random Number{" "}
                  </label>
                  <div className="form-row justify-content-center">
                    <div className="form-group col-md-4">
                      <input
                        name="value"
                        className="form-control"
                        rows="4"
                        defaultValue={convertedValue}
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn outline-text gradient-bg-accent"
                      onClick={() => handleCopy(convertedValue)}
                      disabled={!convertedValue}
                    >
                      <div className="d-flex align-items-center gap">
                        <FontAwesomeIcon className="fa-thin" icon={faCopy} />
                        <span class="pl-2">Copy to Clipboard</span>
                      </div>
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center mt-10 mb-4">
              <Col lg={12} md={8} className="">
                <div className="title text-center m-4">
                  <h1 className="font-weight-bolder line-height-1_4 text-white">
                    Easily{" "}
                    <span className="light-purple-gradient">force update</span>{" "}
                    your mobile apps.
                  </h1>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg={6} md={8}>
                <div className="title text-center mb-5">
                  <span
                    className="text-white text-landing-h1"
                    style={{ fontSize: "2.0rem" }}
                  >
                    Start with{" "}
                    <span className="light-purple-gradient">App Upgrade</span>,
                    today.
                  </span>
                  <p
                    className="light-purple-gradient mt-3"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "normal",
                      color: "rgba(144, 97, 249,1)",
                    }}
                  >
                    Start with <b>free 15 days</b> trial. No credit card
                    required.
                  </p>
                </div>
                <div
                  className="mt-5"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    gap: "1.5rem",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="https://appupgrade.dev/signup"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                    >
                      Get started →
                    </a>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <a
                      target="_blank"
                      href="mailto:support@appupgrade.dev"
                      className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                      rel="noreferrer"
                      style={{ padding: ".375rem .75rem" }}
                    >
                      Contact us →
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </section>
  );
};

export default RandomNumberGenerator;
